import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_2 = { class: "bigTitle" }
const _hoisted_3 = {
  width: "80",
  filter: "createdOn",
  filterType: "dateRange",
  filterFrom: "fromDate",
  filterTo: "toDate",
  sort: "createdOn"
}
const _hoisted_4 = {
  width: "120",
  filter: "user",
  sort: "user.name"
}
const _hoisted_5 = {
  width: "120",
  filter: "fasciaOraria",
  sort: "orario.from"
}
const _hoisted_6 = {
  filter: "cliente",
  sort: "cliente.name"
}
const _hoisted_7 = {
  width: "100",
  filter: "stato",
  sort: "statoHistory[0].value"
}
const _hoisted_8 = {
  width: "200",
  filter: "note",
  sort: "note"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { colspan: "99" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_localized_text, {
          localizedKey: "Prenotazioni ricevute",
          text: "Prenotazioni ricevute"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openImpostaOrariModal && _ctx.openImpostaOrariModal(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Imposta orari di prenotazione",
          text: "Imposta orari di prenotazione"
        })
      ])
    ]),
    _createVNode(_component_op_table, {
      class: "table table-striped",
      itemsPerPage: _ctx.filter.perPage,
      items: _ctx.tableResult.data,
      filter: _ctx.filter,
      totalItemsCount: _ctx.tableResult.count,
      onSearch: _ctx.search
    }, {
      default: _withCtx((opData) => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_3, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data",
                text: "Data"
              })
            ]),
            _createElementVNode("td", _hoisted_4, [
              _createVNode(_component_localized_text, {
                localizedKey: "Centro",
                text: "Centro"
              })
            ]),
            _createElementVNode("td", _hoisted_5, [
              _createVNode(_component_localized_text, {
                localizedKey: "Fascia oraria",
                text: "Fascia oraria"
              })
            ]),
            _createElementVNode("td", _hoisted_6, [
              _createVNode(_component_localized_text, {
                localizedKey: "Cliente",
                text: "Cliente"
              })
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createVNode(_component_localized_text, {
                localizedKey: "Stato",
                text: "Stato"
              })
            ]),
            _createElementVNode("td", _hoisted_8, [
              _createVNode(_component_localized_text, {
                localizedKey: "Note",
                text: "Note"
              })
            ]),
            _hoisted_9
          ])
        ]),
        _createElementVNode("tbody", null, [
          (opData.items.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                _createElementVNode("td", _hoisted_11, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Nessun elemento trovato",
                    text: "Nessun elemento trovato"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.items as OM.PrenotazioneForListVm[]), (item, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.data)), 1),
              _createElementVNode("td", null, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-link text-left",
                  onClick: ($event: any) => (_ctx.centroDetails(item.user))
                }, [
                  _createElementVNode("u", null, _toDisplayString(item.user && item.user.name), 1)
                ], 8, _hoisted_12)
              ]),
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.timespan(item.fasciaOraria.from)) + " - " + _toDisplayString(_ctx.$filters.timespan(item.fasciaOraria.to)), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_router_link, {
                  to: '/clienti/detail/' + item.cliente.identifier
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.cliente && item.cliente.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createElementVNode("td", null, _toDisplayString(item.stato.value), 1),
              _createElementVNode("td", null, _toDisplayString(item.note), 1),
              _createElementVNode("td", null, [
                (item.stato.value != 'Concluso' && item.stato.value != 'Annullato' && item.stato.value != 'Respinto')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.$store.state.isAdmin() || _ctx.$store.state.user.identifier == item.user.identifier)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-success",
                            onClick: ($event: any) => (_ctx.concludiPrenotazione(item.identifier))
                          }, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Concludi",
                              text: "Concludi"
                            })
                          ], 8, _hoisted_13))
                        : _createCommentVNode("", true),
                      (_ctx.$store.state.isAdmin() || _ctx.$store.state.user.identifier == item.user.identifier)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-primary ml-2",
                            onClick: ($event: any) => (_ctx.respingiPrenotazione(item.identifier))
                          }, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Respingi",
                              text: "Respingi"
                            })
                          ], 8, _hoisted_14))
                        : _createCommentVNode("", true),
                      (_ctx.$store.state.isAdmin() || _ctx.$store.state.user.identifier == item.user.identifier)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            type: "button",
                            class: "btn btn-warning ml-2",
                            onClick: ($event: any) => (_ctx.spostaPrenotazione(item))
                          }, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Sposta",
                              text: "Sposta"
                            })
                          ], 8, _hoisted_15))
                        : _createCommentVNode("", true),
                      (_ctx.$store.state.isAdmin() || _ctx.$store.state.user.identifier == item.user.identifier)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 3,
                            type: "button",
                            class: "btn btn-danger ml-2",
                            onClick: ($event: any) => (_ctx.deletePrenotazione(item.identifier))
                          }, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Annulla",
                              text: "Annulla"
                            })
                          ], 8, _hoisted_16))
                        : _createCommentVNode("", true),
                      ((_ctx.$store.state.isAdmin()))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 4,
                            type: "button",
                            class: "btn btn-secondary ml-2",
                            onClick: ($event: any) => (_ctx.dettaglioStatoMacchina(item.identifier))
                          }, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Stato macchina",
                              text: "Stato macchina"
                            })
                          ], 8, _hoisted_17))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["itemsPerPage", "items", "filter", "totalItemsCount", "onSearch"])
  ]))
}